import { jsonData, randomId } from '@/utils/utils'
import { UserDB } from '@/services/db'
import bookSync from '@/services/booksync'
import store from '@/store'

export default class AnnotatorStorage {
  constructor (options) {
    this.db = new UserDB()
    this.book = options.book
    this.page = options.page
    this.accessToken = options.accessToken
  }

	async getFromDB () {
		const query = {
			book: this.book,
			page: this.page
		}

		return (await this.db.getAnnotations(query))
	}

  async create (annotation) {
    let saveAnnotation
    annotation['book'] = this.book
    annotation['page'] = this.page
    annotation['created'] = new Date()

    if (!annotation.id) {
      annotation.id = randomId()
    }
    annotation['metadata'] = {
      'localId': annotation.id
    }

    try {
      saveAnnotation = await bookSync.addUserAnnotation(this.accessToken, annotation)
    } catch {
      saveAnnotation = annotation
    }

    await this.db.annotations.put(jsonData(saveAnnotation))
    // TODO: use hooks
    await store.dispatch('annotations/getAllAnnotationsFromDB')

    return saveAnnotation
  }

  async update (annotation) {
    let saveAnnotation
    annotation['modified'] = new Date()

    try {
      saveAnnotation = await bookSync.updateUserAnnotation(this.accessToken, annotation, annotation.id)
    } catch {
      saveAnnotation = annotation
    }

    await this.db.annotations.put(jsonData(saveAnnotation))
    // TODO: use hooks
    await store.dispatch('annotations/getAllAnnotationsFromDB')

    return saveAnnotation
  }

  async delete (annotation) {
    await this.db.annotations.delete(annotation.id)
    // TODO: use hooks
    await store.dispatch('annotations/getAllAnnotationsFromDB')

    bookSync.deleteUserAnnotation(this.accessToken, annotation.id)
    return annotation
  }
}
